import { persisted } from 'svelte-local-storage-store';
import type { SelectItem, ServiceType } from '../../../../core/types';
import { LOCAL_STORAGE_KEY } from '../../constants';
import { get } from 'svelte/store';

// 필터 스토어 상태 인터페이스
export interface FilterState {
    selectedCountry: SelectItem | null;
    selectedServiceTypes: ServiceType[];
    pendingSelectedCountry: SelectItem | null;
    pendingSelectedServiceTypes: ServiceType[];
    previousSelectedCountryValue: string | null | undefined;
    previousSelectedServiceTypesJson: string | undefined;
}

// 초기 상태
const initialState: FilterState = {
    selectedCountry: null,
    selectedServiceTypes: [],
    pendingSelectedCountry: null,
    pendingSelectedServiceTypes: [],
    previousSelectedCountryValue: undefined,
    previousSelectedServiceTypesJson: undefined,
};

// 필터 스토어 생성
export const createFilterStore = () => {
    const store = persisted<FilterState>(LOCAL_STORAGE_KEY, initialState);

    return {
        ...store,
        subscribe: store.subscribe,
        set: store.set,
        update: store.update,
        getState: () => get(store),

        // 대기 중인 선택된 국가 설정
        setPendingSelectedCountry: (country: SelectItem | null) => store.update(state => ({ ...state, pendingSelectedCountry: country })),

        // 대기 중인 선택된 서비스 타입 설정
        setPendingSelectedServiceTypes: (types: ServiceType[]) => store.update(state => ({ ...state, pendingSelectedServiceTypes: types })),

        // 대기 중인 필터 값을 확정
        confirmPendingFilters: () => {
            store.update(state => ({
                ...state,
                selectedCountry: state.pendingSelectedCountry,
                selectedServiceTypes: [...state.pendingSelectedServiceTypes],
            }));
        },

        // 필터 변경 여부 확인
        checkFiltersChanged: (): boolean => {
            const state = get(store);

            // 이전 상태가 없는 경우 (첫 필터 설정)
            if (state.previousSelectedCountryValue === undefined || state.previousSelectedServiceTypesJson === undefined) {
                return true;
            }

            const newSelectedCountryValue = state.pendingSelectedCountry?.value?.toString() ?? null;
            const newSelectedServiceTypes = [...state.pendingSelectedServiceTypes];
            const newSelectedServiceTypesJson = JSON.stringify(newSelectedServiceTypes.slice().sort());

            // 국가 또는 서비스 타입이 변경된 경우
            return newSelectedCountryValue !== state.previousSelectedCountryValue || newSelectedServiceTypesJson !== state.previousSelectedServiceTypesJson;
        },

        // 스토어 초기화
        reset: () => store.set(initialState),
    };
};

// 싱글톤 인스턴스 생성 및 내보내기
export const searchFilterStore = createFilterStore();
